<div class="flex flex-wrap summary" [formGroup]="AdnexaForm">
  <!-- ==================== Left Section (Start) ==================== -->
  <div class="w-full mdw-1_2 p-5">
    <section class="dashboard-section" style="padding: 32px 24px; margin-bottom: 0">
      <header class="dashboard-section-header">
        <h2>Left Ovary</h2>
      </header>
      <div class="tabs">
        <div role="tablist" aria-label="Left Ovary" (dblclick)="setN('L', null)">
          <a
            role="tab"
            class="tab-normal"
            [attr.aria-selected]="AdnexaForm.get('LObserved').value == 'Normal' ? 'true' : 'false'"
            (click)="setN('L', 'Normal')"
            >Normal</a
          >
          <a
            role="tab"
            [attr.aria-selected]="
              AdnexaForm.get('LObserved').value == 'Abnormal' ? 'true' : 'false'
            "
            (click)="setN('L', 'Abnormal')"
            >Abnormal</a
          >
          <a
            role="tab"
            class="tab-attention"
            [attr.aria-selected]="AdnexaForm.get('LObserved').value === 'Comment' ? 'true' : 'false'"
            (click)="setN('L', 'Comment')"
            >Attention</a
          >
        </div>
      </div>
      <div class="w100 summary-spreadHeight summary-diagnosis" style="margin-top: 2em">
        <section
          class="m-box"
          style="height: 100px; padding: 1.31em 0; box-shadow: none; border: 0; background: none"
        >
          <h2 style="margin-bottom: 16px; font-size: inherit; font-weight: 400">Comments</h2>
          <textarea class="scroller" formControlName="LComments"></textarea>

          <button
            class="t-btn-edit"
            *ngIf="!es.isClosed"
            (click)="atS.showAuto(AdnexaForm.get('LComments'), 'Left Ovary Comment', 82)"
          >
            Auto Text
          </button>
        </section>
      </div>
      <hr />
      <div role="tabpanel" id="tab1">
        <div class="flex">
          <div class="flex items-center flex-grow">
            <label for="input1">L</label>
            <div class="sep-16"></div>
            <div class="flex items-center t-field t-field--number">
              <input type="number" id="input1" class="t-field-text" formControlName="LSizeX" />
              <span class="t-field-desc">mm</span>
            </div>
          </div>
          <div class="sep-16"></div>
          <div class="flex items-center flex-grow">
            <label for="input2">W</label>
            <div class="sep-16"></div>
            <div class="flex items-center t-field t-field--number">
              <input type="number" id="input2" class="t-field-text" formControlName="LSizeY" />
              <span class="t-field-desc">mm</span>
            </div>
          </div>
          <div class="sep-16"></div>
          <div class="flex items-center flex-grow">
            <label for="input3">H</label>
            <div class="sep-16"></div>
            <div class="flex items-center t-field t-field--number">
              <input type="number" id="input3" class="t-field-text" formControlName="LSizeZ" />
              <span class="t-field-desc">mm</span>
            </div>
          </div>
          <div class="sep-16"></div>
          <div class="flex items-center flex-grow">
            <label for="input4">&nbsp;</label>
            <div class="sep-16"></div>
            <div class="flex items-center t-field t-field--number">
              <input type="number" id="input4" class="t-field-text" formControlName="LSizeVol" />
              <span class="t-field-desc">cc</span>
            </div>
          </div>
        </div>
        <div class="sep"></div>
        <div style="display: flex; align-items: center">
          <h4 style="white-space: nowrap; margin-right: 1em">Ovarian Cyst</h4>
          <div class="tabs" style="padding: 0.5em; width: 100%; margin: 1em 0 !important">
            <div
              role="tablist"
              aria-label="Left Ovarian Cyst"
              (dblclick)="setN('LOvarianCyst', null)"
            >
              <a
                role="tab"
                [attr.aria-selected]="
                  AdnexaForm.get('LOvarianCystObserved').value == 'Yes' ? 'true' : 'false'
                "
                (click)="setN('LOvarianCyst', 'Yes')"
              >
                Yes
              </a>
              <a
                role="tab"
                class="tab-normal"
                [attr.aria-selected]="
                  AdnexaForm.get('LOvarianCystObserved').value == 'No' ? 'true' : 'false'
                "
                (click)="setN('LOvarianCyst', 'No')"
              >
                No
              </a>
              <a
                role="tab"
                class="tab-attention"
                [attr.aria-selected]="
                  AdnexaForm.get('LOvarianCystObserved').value === 'Comment' ? 'true' : 'false'
                "
                (click)="setN('LOvarianCyst', 'Comment')"
              >
                Attention
              </a>
            </div>
          </div>
          <div class="flex items-center flex-grow" style="margin-left: 1em">
            <label for="input3">AFC</label>
            <div class="sep-16"></div>
            <div class="flex items-center t-field t-field--number">
              <input type="number" id="input3" class="t-field-text" formControlName="LAFC" />
            </div>
          </div>
        </div>
        <div class="w100 summary-spreadHeight summary-diagnosis">
          <section
            class="m-box"
            style="
              height: 100px;
              padding: 1.31em 0;
              box-shadow: none;
              border: 0;
              background: none;
            "
          >
            <h2 style="margin-bottom: 16px; font-size: inherit; font-weight: 400">Comments</h2>
            <textarea class="scroller" formControlName="LOvaryComments"></textarea>
            <button
              class="t-btn-edit"
              *ngIf="!es.isClosed"
              (click)="
                atS.showAuto(
                  AdnexaForm.get('LOvaryComments'),
                  'Left Ovarian Cyst Comment',
                  AutoTextUUIDs.LOvaryComments
                )
              "
            >
              Auto Text
            </button>
          </section>
        </div>
        <hr />
        <div style="display: flex; align-items: center">
          <h4 style="white-space: nowrap; margin-right: 1em">Left Fallopian Tube</h4>
          <div class="tabs" style="padding: 0.5em; width: 100%; margin: 1em 0 !important">
            <div
              role="tablist"
              aria-label="Left Ovary"
              (dblclick)="setN('LFallopianTube', null)"
            >
              <a
                role="tab"
                class="tab-normal"
                [attr.aria-selected]="
                  AdnexaForm.get('LFallopianTubeObserved').value == 'Normal' ? 'true' : 'false'
                "
                (click)="setN('LFallopianTube', 'Normal')"
              >
                Normal
              </a>
              <a
                role="tab"
                [attr.aria-selected]="
                  AdnexaForm.get('LFallopianTubeObserved').value == 'Abnormal' ? 'true' : 'false'
                "
                (click)="setN('LFallopianTube', 'Abnormal')"
              >
                Abnormal
              </a>
              <a
                role="tab"
                class="tab-attention"
                [attr.aria-selected]="
                  AdnexaForm.get('LFallopianTubeObserved').value === 'Comment' ? 'true' : 'false'
                "
                (click)="setN('LFallopianTube', 'Comment')"
              >
                Attention
              </a>
            </div>
          </div>
        </div>
        <div class="w100 summary-spreadHeight summary-diagnosis">
          <section
            class="m-box"
            style="
              height: 100px;
              padding: 1.31em 0;
              box-shadow: none;
              border: 0;
              background: none;
            "
          >
            <h2 style="margin-bottom: 16px; font-size: inherit; font-weight: 400">Comments</h2>
            <textarea class="scroller" formControlName="LFTubeComments"></textarea>

            <button
              class="t-btn-edit"
              *ngIf="!es.isClosed"
              (click)="
                atS.showAuto(
                  AdnexaForm.get('LFTubeComments'),
                  'Left Fallopian Tube Comment',
                  AutoTextUUIDs.LFTubeComments
                )
              "
            >
              Auto Text
            </button>
          </section>
        </div>
      </div>
      <div role="tabpanel" id="tab2" hidden>Abnormal Left</div>
      <div role="tabpanel" id="tab3" hidden>Comment Left</div>
    </section>
  </div>
  <!-- ==================== Left Section (End) ==================== -->

  <!-- ==================== Right Section (Start) ==================== -->
  <div class="w-full mdw-1_2 p-5">
    <section class="dashboard-section" style="padding: 32px 24px; margin-bottom: 0">
      <header class="dashboard-section-header">
        <h2>Right Ovary</h2>
      </header>
      <div class="tabs">
        <div role="tablist" aria-label="Left Ovary" (dblclick)="setN('R', null)">
          <a
            role="tab"
            class="tab-normal"
            [attr.aria-selected]="AdnexaForm.get('RObserved').value == 'Normal' ? 'true' : 'false'"
            (click)="setN('R', 'Normal')"
            >Normal</a
          >
          <a
            role="tab"
            [attr.aria-selected]="
              AdnexaForm.get('RObserved').value == 'Abnormal' ? 'true' : 'false'
            "
            (click)="setN('R', 'Abnormal')"
            >Abnormal</a
          >
          <a
            role="tab"
            class="tab-attention"
            [attr.aria-selected]="AdnexaForm.get('RObserved').value === 'Comment' ? 'true' : 'false'"
            (click)="setN('R', 'Comment')"
            >Attention</a
          >
        </div>
      </div>
      <div class="w100 summary-spreadHeight summary-diagnosis" style="margin-top: 2em">
        <section
          class="m-box"
          style="height: 100px; padding: 1.31em 0; box-shadow: none; border: 0; background: none"
        >
          <h2 style="margin-bottom: 16px; font-size: inherit; font-weight: 400">Comments</h2>
          <textarea class="scroller" formControlName="RComments"></textarea>

          <button
            class="t-btn-edit"
            *ngIf="!es.isClosed"
            (click)="atS.showAuto(AdnexaForm.get('RComments'), 'Right Ovary Comment', 82)"
          >
            Auto Text
          </button>
        </section>
      </div>
      <hr />
      <div role="tabpanel" id="tab4">
        <div class="flex">
          <div class="flex items-center flex-grow">
            <label for="input1">L</label>
            <div class="sep-16"></div>
            <div class="flex items-center t-field t-field--number">
              <input
                type="number"
                id="input1"
                class="t-field-text"
                min="0"
                formControlName="RSizeX"
              />
              <span class="t-field-desc">mm</span>
            </div>
          </div>
          <div class="sep-16"></div>
          <div class="flex items-center flex-grow">
            <label for="input2">W</label>
            <div class="sep-16"></div>
            <div class="flex items-center t-field t-field--number">
              <input
                type="number"
                id="input2"
                class="t-field-text"
                min="0"
                formControlName="RSizeY"
              />
              <span class="t-field-desc">mm</span>
            </div>
          </div>
          <div class="sep-16"></div>
          <div class="flex items-center flex-grow">
            <label for="input3">H</label>
            <div class="sep-16"></div>
            <div class="flex items-center t-field t-field--number">
              <input
                type="number"
                id="input3"
                class="t-field-text"
                min="0"
                formControlName="RSizeZ"
              />
              <span class="t-field-desc">mm</span>
            </div>
          </div>
          <div class="sep-16"></div>
          <div class="flex items-center flex-grow">
            <label for="input4">&nbsp;</label>
            <div class="sep-16"></div>
            <div class="flex items-center t-field t-field--number">
              <input type="number" id="input4" class="t-field-text" formControlName="RSizeVol" />
              <span class="t-field-desc">cc</span>
            </div>
          </div>
        </div>
        <div class="sep"></div>
        <div style="display: flex; align-items: center">
          <h4 style="white-space: nowrap; margin-right: 1em">Ovarian Cyst</h4>
          <div class="tabs" style="padding: 0.5em; width: 100%; margin: 1em 0 !important">
            <div
              role="tablist"
              aria-label="Right Ovarian Cyst"
              (dblclick)="setN('ROvarianCyst', null)"
            >
              <a
                role="tab"
                [attr.aria-selected]="
                  AdnexaForm.get('ROvarianCystObserved').value == 'Yes' ? 'true' : 'false'
                "
                (click)="setN('ROvarianCyst', 'Yes')"
              >
                Yes
              </a>
              <a
                role="tab"
                class="tab-normal"
                [attr.aria-selected]="
                  AdnexaForm.get('ROvarianCystObserved').value == 'No' ? 'true' : 'false'
                "
                (click)="setN('ROvarianCyst', 'No')"
              >
                No
              </a>
              <a
                role="tab"
                class="tab-attention"
                [attr.aria-selected]="
                  AdnexaForm.get('ROvarianCystObserved').value === 'Comment' ? 'true' : 'false'
                "
                (click)="setN('ROvarianCyst', 'Comment')"
              >
                Attention
              </a>
            </div>
          </div>
          <div class="flex items-center flex-grow" style="margin-left: 1em">
            <label for="input3">AFC</label>
            <div class="sep-16"></div>
            <div class="flex items-center t-field t-field--number">
              <input type="number" id="input3" class="t-field-text" formControlName="RAFC" />
            </div>
          </div>
        </div>
        <div class="w100 summary-spreadHeight summary-diagnosis">
          <section
            class="m-box"
            style="
              height: 100px;
              padding: 1.31em 0;
              box-shadow: none;
              border: 0;
              background: none;
            "
          >
            <h2 style="margin-bottom: 16px; font-size: inherit; font-weight: 400">Comments</h2>
            <textarea class="scroller" formControlName="ROvaryComments"></textarea>
            <button
              class="t-btn-edit"
              *ngIf="!es.isClosed"
              (click)="
                atS.showAuto(
                  AdnexaForm.get('ROvaryComments'),
                  'Right Ovarian Cyst Comment',
                  AutoTextUUIDs.ROvaryComments
                )
              "
            >
              Auto Text
            </button>
          </section>
        </div>
        <hr />
        <div style="display: flex; align-items: center">
          <h4 style="white-space: nowrap; margin-right: 1em">Right Fallopian Tube</h4>
          <div class="tabs" style="padding: 0.5em; width: 100%; margin: 1em 0 !important">
            <div
              role="tablist"
              aria-label="Left Ovary"
              (dblclick)="setN('RFallopianTube', null)"
            >
              <a
                role="tab"
                class="tab-normal"
                [attr.aria-selected]="
                  AdnexaForm.get('RFallopianTubeObserved').value == 'Normal' ? 'true' : 'false'
                "
                (click)="setN('RFallopianTube', 'Normal')"
              >
                Normal
              </a>
              <a
                role="tab"
                [attr.aria-selected]="
                  AdnexaForm.get('RFallopianTubeObserved').value == 'Abnormal' ? 'true' : 'false'
                "
                (click)="setN('RFallopianTube', 'Abnormal')"
              >
                Abnormal
              </a>
              <a
                role="tab"
                class="tab-attention"
                [attr.aria-selected]="
                  AdnexaForm.get('RFallopianTubeObserved').value === 'Comment' ? 'true' : 'false'
                "
                (click)="setN('RFallopianTube', 'Comment')"
              >
                Attention
              </a>
            </div>
          </div>
        </div>
        <div class="w100 summary-spreadHeight summary-diagnosis">
          <section
            class="m-box"
            style="
              height: 100px;
              padding: 1.31em 0;
              box-shadow: none;
              border: 0;
              background: none;
            "
          >
            <h2 style="margin-bottom: 16px; font-size: inherit; font-weight: 400">Comments</h2>
            <textarea class="scroller" formControlName="RFTubeComments"></textarea>

            <button
              class="t-btn-edit"
              *ngIf="!es.isClosed"
              (click)="
                atS.showAuto(
                  AdnexaForm.get('RFTubeComments'),
                  'Right Fallopian Tube Comment',
                  AutoTextUUIDs.RFTubeComments
                )
              "
            >
              Auto Text
            </button>
          </section>
        </div>
      </div>
      <div role="tabpanel" id="tab5" hidden>Abnormal Left</div>
      <div role="tabpanel" id="tab6" hidden>Comment Left</div>
    </section>
  </div>
  <!-- ==================== Right Section (End) ==================== -->

  <!-- ==================== P.O.D Section (Start) ==================== -->
  <div class="w50 p-5 summary">
    <section class="dashboard-section" style="padding: 32px 24px; margin-bottom: 0">
      <header class="dashboard-section-header">
        <h2>
          {{ 'GUI.Gynecology.Ovaries.POD' | translate }}
        </h2>
      </header>
      <div class="l-flex-c cervical-row">
        <label class="cervical-label" id="funneling">
          {{ 'GUI.Gynecology.Ovaries.Fluid' | translate }}
        </label>

        <div class="sep-16"></div>
        <app-genradio
          formname="Fluid"
          [formgroup]="AdnexaForm"
          [value1]="0"
          [value2]="1"
          [lname]="'general.PositiveNegative.yes' | translate"
          [rname]="'general.PositiveNegative.No' | translate"
          [resetval]="-1"
        ></app-genradio>
      </div>
      <div class="sep-32" style="margin: 16px 0"></div>
      <div class="w100 summary-spreadHeight summary-diagnosis summary">
        <section
          class="m-box"
          style="height: 173px; padding: 1.31em 0; box-shadow: none; border: 0; background: none"
        >
          <h2 style="margin-bottom: 16px; font-size: inherit; font-weight: 400">
            {{ 'GUI.Gynecology.Ovaries.Comments' | translate }}
          </h2>

          <textarea class="scroller" formControlName="Comments"></textarea>

          <button
            class="t-btn-edit"
            *ngIf="!es.isClosed"
            (click)="atS.showAuto(AdnexaForm.get('Comments'), atSTitlePODComments, 83)"
          >
            Auto Text
          </button>
        </section>
      </div>
    </section>
  </div>
  <!-- ==================== P.O.D Section (End) ==================== -->

  <div class="w50 p-5 summary" style="padding: 1em">
    <app-diagnoses
      group="adnexa"
      [form]="AdnexaForm.get('DiagnosisCodes')"
      [text]="AdnexaForm.get('Diagnosis')"
      autoid="85"
      class="w100 summary-boxHeight summary-extradocs"
    ></app-diagnoses>
  </div>
</div>
